<template>
  <div class='surveys-table'>
    <base-table
      v-if="logsAPi && logsAPiMeta"
      :columns='columns'
      :data='logsAPi'
      :total-items='logsAPiMeta.total'
      :start-items='logsAPiMeta.skip + 1'
      :max-items='logsAPiMeta.limit'
      @set-page='handleChangeUpdateLogs'
    >
      <template v-slot:body-partnerId.email='row'>
        {{ row.item.partnerId.email ? row.item.partnerId.email : '' }}
      </template>

      <template v-slot:body-createdAt='row'>
        {{ formatDate(row.item.createdAt) }}
      </template>

      <template v-slot:body-whatTheSearchReturned='row'>
        <p class="whatTheSearchReturned">
        {{ row.item.whatTheSearchReturned }}
        </p>
      </template>
    </base-table>
  </div>
</template>

<script>
import format from 'date-fns/esm/format/index'
import { mapActions } from 'vuex'

export default {
  name: 'ApiKeyTable',
  props: {
    logsAPi: { type: Array, require: true },
    logsAPiMeta: { type: Object, require: true }
  },
  async created() {
  },
  data() {
    return {
      logUpdate: {},
      openDialog: false,
      columns: [
        { key: 'partnerId.email', value: 'Parceiro' },
        { key: 'createdAt', value: 'Data' },
        { key: 'whatWasSearched', value: 'Pesquisado' },
        { key: 'whatTheSearchReturned', value: 'Retornado' },
      ]
    }
  },
  components: {
  },
  methods: {
    ...mapActions('logApi', {
      handleGetLogsAPi: 'handleGetLogsAPi',
    }),
    async showToastResponse(message) {
      this.$bvToast.toast(message, {
        title: 'Aviso',
        variant: 'success',
        toaster: 'b-toaster-top-center',
        autoHideDelay: 5000
      })
      await this.handleGetPartners()
      this.close()
    },
    async seeMoreUser(_id) {
      this.$emit('update-partner', _id)
    },
    formatDate(date) {
      return format(new Date(date), 'dd/MM/yyyy HH:mm:ss')
    },

    handleChangeUpdateLogs(page) {
      const pageCount = page <= 0 ? 1 : page
      const params = {
        skip: ((pageCount - 1) * this.logsAPiMeta.limit)
      }
      this.$emit('change-logs', params)
    },

    show() {
      this.$refs['show-log'].show()
    },

    close() {
      this.$refs['show-log'].hide()
    }
  }
}
</script>

<style lang='scss' scoped>
.api-key {
  max-width: 300px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.whatTheSearchReturned{
  text-align: justify
}
.surveys-table {
  display: flex;
  flex-direction: column;
  gap: 16px;

  i {
    cursor: pointer;

    &:hover(:not(.fa-ban)) {
      opacity: 0.95;
    }
  }
}
</style>
